import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { priceFormat } from '../../../../util';
import { oneBtnPopupCreator, twoBtnPopupCreator } from '../../../popups/ConfirmPopup/helper';
import * as Styled from '../SimplrOrder.styles';
import Loading from '../../../LoadingComponent/LoadingComponent';
import moment from 'moment';
import ImageIcon from '../../../ImageIcon/ImageIcon';
import { PolicySeparationLine, PolicyTitle, PolicyWrapper } from '../../../common/policyStyles';
import { Button, FullColoredButton } from '../../../common/buttonsComponents';
import { connect } from 'react-redux';
import { setSelectedTask } from '../../../../actions/tools/OrdersSearchActions';
import { refundSimplrStoreCredit } from '../../../../actions/tools/SimplrOrderActions';
import { addNoteToTicket } from '../../../../actions';
import {
  getSelectedOrderFromOrdersSearch,
  extractSelectedInboxTab,
  extractSelectedTicketFromState,
  isSpecialist,
} from '../../../../extractFromState';
import { selectSelectedToolDomains } from '../../../../selectors/tools';
import { showErrorPopup } from 'components/popups/ErrorPopup/ErrorPopup';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import {
  IssueStoreCreditButton,
  PolicyDescriptionError,
  CancelStep,
  StepTitle,
  Subtext,
  RowContent,
  ErrorMessage,
  RefundRowContent,
  RefundCommentTextarea,
  FlexPlaceholder,
  OrderSummaryBox,
  OrderSummaryHeader,
  DollarInputField,
  CentInputField,
  OrderSummaryInfo,
  OrderSubtotalInfo,
} from './SimplrRefundStoreCredit.styles';
import { handleError } from 'services/ErrorService/ErrorService';

const DESCRIPTION_WITH_CANCELABLE = `Please specify the amount you want to issue as store credit to the customer.`;
const CUSTOMER_UNREGISTERED_MESSAGE =
  'The customer is using a guest account. Credits may only be issued to registered users.';
const UNREGISTERED = 'unregistered';

export class SimplrRefundStoreCredit extends Component {
  static propTypes = {
    selectedOrder: PropTypes.object.isRequired,
    selectedTicket: PropTypes.object,
    setSelectedTask: PropTypes.func,
    selectedToolDomains: PropTypes.object,
    isSpecialist: PropTypes.bool,
  };

  static defaultProps = {
    setSelectedTask: () => {},
  };

  async componentDidMount() {
    // TO DO: create an action for fetching OrderDetails
    const selectedOrder = this.props.selectedOrder;
    const shippedItems = (selectedOrder['orderItems'] || []).filter((item) => item['itemShippingStatus'] === 'Shipped');
    const actualRefundableItems = (selectedOrder['orderItems'] || []).filter(
      (item) => item['itemShippingStatus'] !== 'Shipped'
    );

    const selectedItems = {};
    for (let refundableItem of selectedOrder['orderItems']) {
      selectedItems[refundableItem['itemId']] = {
        qty: 1,
        active: true,
      };
    }
    const shippingCost = selectedOrder['shippingCost'];
    const status = selectedOrder['orderStatus'];
    const isCustomerUnregistered = get(selectedOrder, 'customer.customerStatus', null) === UNREGISTERED;

    this.setState({
      refundableItems: actualRefundableItems,
      shippedItems,
      selectedItems,
      status,
      shippingCost,
      isCustomerUnregistered,
      isCancelOrderItemsRequesting: false,
    });
  }

  state = {
    dollarAmount: 0,
    centAmount: 0,
    storeCreditAmount: 0.0,
    status: '',
    shippingCost: 0.0,
    currencyCode: 'USD',
    refundableItems: [],
    notRefundableItems: [],
    shippedItems: [],
    selectedItems: {},
    reasonComment: '',
    reasonError: false,
    isCancelRequesting: false,
    isCancelOrderItemsRequesting: true,
    isPolicyAccepted: false,
    isCustomerUnregistered: false,
    errors: {},
  };

  get orderId() {
    return this.props.selectedOrder.orderId;
  }

  // ------------
  // Policy things
  // ------------

  get totalRefund() {
    return get(this, 'state.summaryBlock.totals.total', 0);
  }

  get refundLimitPrice() {
    return this.refundConfig['refundPolicyPrice'] ? parseInt(this.refundConfig.refundPolicyPrice) : 0;
  }

  get refundLimitDays() {
    return this.refundConfig['refundPolicyDays'] ? this.refundConfig.refundPolicyDays : 0;
  }

  get isPolicyAccepted() {
    return this.state.isPolicyAccepted;
  }

  get isSpecialist() {
    return this.props.isSpecialist;
  }

  get createdDate() {
    return (this.props.selectedOrder || {}).created_at || '';
  }

  renderPolicy() {
    return (
      <PolicyWrapper>
        <PolicyTitle>What is the Refund policy?</PolicyTitle>
        <ImageIcon src={ImageIcon.type.magnifiedDocument} className="top-image" />
        {this.refundConfig['refundPolicyText'] ? <p>{this.refundConfig['refundPolicyText']}</p> : ''}
        {this.refundLimitDays ? (
          <PolicyDescriptionError isError={this.isRefundDateLimitExceeded()}>
            Orders are available to refund after creation for {this.refundLimitDays} days from order date:{' '}
            {moment(this.createdDate).format('MM/DD/YYYY')}.
          </PolicyDescriptionError>
        ) : (
          ''
        )}
        {this.refundLimitPrice ? <p>Available for one refund ${this.refundLimitPrice}.</p> : ''}
        <PolicySeparationLine />
        {this.refundLimitDays === 0 || !this.isRefundDateLimitExceeded() ? (
          <FullColoredButton type="button" onClick={() => this.setState({ isPolicyAccepted: true })}>
            GO
          </FullColoredButton>
        ) : (
          ''
        )}
      </PolicyWrapper>
    );
  }

  // ------------
  // Step 2
  // ------------

  handlerTextInputChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  // ------------
  // Totals
  // ------------

  get placeholderText() {
    // TODO: Make this if string readable
    return DESCRIPTION_WITH_CANCELABLE;
  }

  /**
   * Formatting price with currency sign
   * @example 12 -> $12.00
   * @param {string|number} value
   * @return {string}
   */
  priceFormat = (value) => priceFormat(value, this.state.currencyCode);

  handleBackBtnClick = () => {
    this.props.setSelectedTask(null);
  };

  // ------------
  // Refund process
  // ------------

  displayPopupErrorMessage(message = '') {
    return oneBtnPopupCreator({
      content: {
        main: message,
        iconPath: '/images/error-esclamation.svg',
      },
      btnConfig: 'CLOSE',
    });
  }

  isRefundLimitExceeded() {
    return this.refundLimitPrice !== 0 ? this.refundLimitPrice <= this.totalRefund : false;
  }

  handleRefundBtnClick = () => {
    if (!this.state.reasonComment) {
      this.setState({ reasonError: true });

      return this.displayPopupErrorMessage('Please add reason for refund');
    }
    if (this.isRefundLimitExceeded()) {
      return this.displayPopupErrorMessage(`Partner limits for refund $${this.refundLimitPrice}`);
    }
    this.setState({ reasonError: false });

    twoBtnPopupCreator({
      content: {
        main: 'Are you sure you want to refund this store credit?',
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'DISMISS',
        confirm: 'ISSUE STORE CREDIT',
      },
      onConfirm: this.confirmationHandler,
    });
  };

  confirmationHandler = async () => {
    let messageBody = '';
    messageBody += `Cancel note, Order #${this.orderId}.\n`;
    messageBody += `Reason for cancel: ${this.state.reasonComment}\n`;
    messageBody += `Amount refunded: $${parseFloat(this.totalRefund).toFixed(2)}`;

    this.setState({ isCancelRequesting: true });

    const customerId = this.props.selectedOrder.customer['customerId'];

    const payload = {
      customerId: customerId,
      creditAmount: parseFloat(this.state.storeCreditAmount),
      domain: this.props.domain,
    };

    const { simplrAccountPtrId } = this.props.selectedTicket;

    try {
      await this.props.refundSimplrStoreCredit(simplrAccountPtrId, this.orderId, payload);
      if (this.props.selectedInboxTab === 'assigned') {
        await this.props.addNoteToTicket(messageBody, this.props.selectedTicket);
      }

      this.handleSuccessRefund();
    } catch (e) {
      // We have to do this because axios is returning a string that we can't parse directly. It's automatically combining the data object as a string with the error message
      // and we still don't know why - 5/6/2019
      let errorMessage;
      const errorArray = e.message.split('Not Found');
      errorArray.length > 1 ? (errorMessage = JSON.parse(errorArray[1]).errorMessage) : (errorMessage = undefined);
      this.handleFailedRefund(errorMessage);
      handleError({ error: e, customMessage: errorMessage });
    }
  };

  handleSuccessRefund = () => {
    this.setState({ isCancelRequesting: false });

    this.props.setSelectedTask(null);

    oneBtnPopupCreator({
      content: {
        main: `Issue store credit successful: Issued ${parseFloat(this.state.storeCreditAmount).toFixed(2)}${
          this.state.currencyCode
        }`,
        iconPath: '/images/checkmark-green.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  handleFailedRefund = (message = undefined) => {
    this.setState({ isCancelRequesting: false });
    if (message === undefined) {
      oneBtnPopupCreator({
        content: {
          main: 'Cancel order failed',
          iconPath: '/images/error-esclamation.svg',
        },
        btnConfig: 'CLOSE',
      });
    } else {
      oneBtnPopupCreator({
        content: {
          main: `${message}`,
          iconPath: '/images/error-esclamation.svg',
        },
        btnConfig: 'CLOSE',
      });
    }
  };

  handleUnregisteredUser = () => {
    showErrorPopup(CUSTOMER_UNREGISTERED_MESSAGE);
    this.handleBackBtnClick();

    return null;
  };

  calculateStoreCreditAmount(amount, type) {
    let storeCreditAmount;
    const currentStoreCreditAmount = this.state.storeCreditAmount;
    if (type === 'dollar') {
      let currentCentAmount;
      isNaN(parseFloat(this.state.centAmount) / 100)
        ? (currentCentAmount = 0)
        : (currentCentAmount = parseFloat(this.state.centAmount) / 100);
      storeCreditAmount = parseFloat(amount) + currentCentAmount;
    } else {
      storeCreditAmount = Math.floor(currentStoreCreditAmount) + parseFloat(amount) / 100;
    }
    this.setState({ storeCreditAmount });
  }

  changeDollarAmount(newValue) {
    let dollarAmount;
    let errors = cloneDeep(this.state.errors);
    if (newValue.target.value === '') {
      dollarAmount = '';
      if (errors.refundAmountError) {
        errors.refundAmountError = undefined;
      }
    } else {
      if (isNaN(newValue.target.value)) {
        dollarAmount = 0;
        errors.refundAmountError = 'Please enter a number into the field.';
      } else {
        dollarAmount = newValue.target.value;
        if (errors.refundAmountError) {
          errors.refundAmountError = undefined;
        }
      }
    }
    dollarAmount === ''
      ? this.calculateStoreCreditAmount(0, 'dollar')
      : this.calculateStoreCreditAmount(dollarAmount, 'dollar');
    this.setState({ dollarAmount, errors });
  }

  changeCentAmount(newValue) {
    let centAmount;
    let errors = cloneDeep(this.state.errors);
    if (newValue.target.value === '') {
      centAmount = '';
      if (errors.refundAmountError) {
        errors.refundAmountError = undefined;
      }
    } else {
      if (isNaN(newValue.target.value)) {
        centAmount = 0;
        errors.refundAmountError = 'Please enter a number into the field.';
      } else if (newValue.target.value.length > 2) {
        centAmount = this.state.centAmount;
        errors.refundAmountError = "You can't enter more than 2 digits for the cent amount";
      } else {
        centAmount = newValue.target.value;
        if (errors.refundAmountError) {
          errors.refundAmountError = undefined;
        }
      }
    }
    centAmount === ''
      ? this.calculateStoreCreditAmount(0, 'cent')
      : this.calculateStoreCreditAmount(centAmount, 'cent');
    this.setState({ centAmount, errors });
  }

  // ------------
  // Renders
  // ------------

  renderComponent() {
    const storeCreditAmountJSX = (
      <div>
        <Styled.OrderTaskTitle>Refund Amount:</Styled.OrderTaskTitle>
        <br />
        <RefundRowContent>
          $
          <DollarInputField value={this.state.dollarAmount} onChange={(value) => this.changeDollarAmount(value)} />
          .
          <CentInputField value={this.state.centAmount} onChange={(value) => this.changeCentAmount(value)} />
        </RefundRowContent>
        <RefundRowContent>
          {this.state.errors.refundAmountError ? (
            <ErrorMessage>{this.state.errors.refundAmountError}</ErrorMessage>
          ) : (
            ''
          )}
        </RefundRowContent>
      </div>
    );

    return (
      <div>
        <Styled.OrderTaskWrapper>
          <Styled.OrderTaskTitle>Issue store credit</Styled.OrderTaskTitle>
          <Styled.OrderTaskDescription>{this.placeholderText}</Styled.OrderTaskDescription>
          {storeCreditAmountJSX}
          <CancelStep>
            <StepTitle>
              <Subtext>Step 2 - </Subtext>Select reason for issuing store credit (mandatory)
            </StepTitle>
            <RowContent>
              <RefundCommentTextarea
                name="reasonComment"
                value={this.state.reasonComment}
                onChange={this.handlerTextInputChange}
              />
              <FlexPlaceholder />
              <OrderSummaryBox>
                <OrderSummaryHeader>Credit Summary:</OrderSummaryHeader>
                <OrderSummaryInfo>
                  <RowContent>
                    <OrderSubtotalInfo>Credit total</OrderSubtotalInfo>
                    <OrderSubtotalInfo>
                      {this.priceFormat(parseFloat(this.state.storeCreditAmount).toFixed(2))}
                    </OrderSubtotalInfo>
                  </RowContent>
                </OrderSummaryInfo>
              </OrderSummaryBox>
            </RowContent>
          </CancelStep>
          <Styled.OrderTaskControls>
            <Button onClick={this.handleBackBtnClick}>BACK</Button>
            <IssueStoreCreditButton active={true} onClick={this.handleRefundBtnClick}>
              ISSUE STORE CREDIT
            </IssueStoreCreditButton>
          </Styled.OrderTaskControls>
        </Styled.OrderTaskWrapper>
      </div>
    );
  }

  render() {
    if (this.state.isCustomerUnregistered) {
      return this.handleUnregisteredUser();
    }
    if (this.state.isCancelRequesting) {
      return <Loading label="Refund order..." />;
    }
    if (this.state.isCancelOrderItemsRequesting) {
      return <Loading label="Loading cancel information..." />;
    }

    return this.renderComponent();
  }
}

const mapStateToProps = (state) => {
  const selectedOrder = getSelectedOrderFromOrdersSearch(state);

  return {
    selectedOrder: selectedOrder,
    selectedTicket: extractSelectedTicketFromState(state),
    selectedInboxTab: extractSelectedInboxTab(state),
    selectedToolDomains: selectSelectedToolDomains(state),
    isSpecialist: isSpecialist(state),
    domain: selectedOrder.domain || null,
  };
};

export default connect(mapStateToProps, {
  setSelectedTask,
  addNoteToTicket,
  refundSimplrStoreCredit,
})(SimplrRefundStoreCredit);
